import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import App from './modules/App/App';
import store from './redux/configureReduxStore';
import 'antd/dist/antd.css';

const initApp = () => (
    render(
        <Provider store={store}>
            <App store={store} />
        </Provider>,
        document.getElementById('root'),
    )
);

initApp();



// WEBPACK FOOTER //
// ./src/index.js